import { useEffect } from 'react'

const PIXEL_ID = '1404742387373119'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    window.fbq('track', 'PageView')
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Farmacia de Despensa - El Botiquín de Cocina',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
